module.exports = __webpack_public_path__ + "static/media/kindLeatherLogo21.8b2bb319.png";